import { VERSION_INFO } from './version';

export const environment = {
  production: true,
  baseUrl: '/',
  version: VERSION_INFO.version
};
